const getters = {
  sidebar: state => state.app.sidebar,
  giftCards: state => state.app.giftCards,
  device: state => state.app.device,
  permission_routes: state => state.permission.routes,
};
export default getters;
